export default function ($) {

  // https://select2.org/getting-started/basic-usage

  $.fn.select2.amd.define('select2/i18n/fr', [], function () {
    return {
      errorLoading: function () {
        return 'Une erreur est survenue, veuillez réessayer.';
      },
      inputTooShort: function (args) {
        return "Merci de saisir au moins " + args.minimum + " caractères";
      },
      inputTooLong: function (args) {
        return "Merci de saisir au plus " + args.minimum + " caractères";
      },
      loadingMore: function () {
        return "Charger plus de résultats";
      },
      noResults: function () {
        return "Aucun résultat, veuillez essayer d'autres mots clefs";
      },
      searching: function () {
        return 'Recherche en cours...';
      }
    }
  })

  let defaultSelect2Config = {
    minimumInputLength: 3,
    allowClear: true,
    language: 'fr',
    escapeMarkup: function (text) { return text }, // do not escape text, it's html safe
  }

  let accountJobSiteIdInput = $('.js-account-job-site-id')
  if (accountJobSiteIdInput.length > 0) {
    accountJobSiteIdInput.select2(Object.assign(defaultSelect2Config, {
      placeholder: "Commencer à saisir le nom ou l'adresse du site recherché (ex: CHU)",
      ajax: {
        url: client_configuration.ajax_url,
        data: function (params) {
          return {
            action: 'client_site_id_search',
            search: params.term,
            page: params.page || 1,
          }
        },
        dataType: 'json'
      }
    })).on('select2:select', function (e) {
      $(this).parents('form').submit() // force refresh to update unit select
    })
  }

}
